import './index.css'

import ReactDOM from 'react-dom/client'

import App from './App.tsx'

ReactDOM.createRoot(document.getElementById('root')!).render(
  // StrictMode temporarily disabled to reduce double-mount noise during QA
  // <React.StrictMode>
    <App />
  // </React.StrictMode>,
)

